import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import { styled as muiStyled } from "@mui/system";
import { globalColors } from "../../Utils/colors";

export const RootContainer = muiStyled(Box)({
  height: "100vh",
  overflow: "hidden",
});

export const HeaderContainer = muiStyled(Box)({
  height: "55px",
  display: "flex",
  alignItems: "center",
});

export const HeaderInnerGrid = muiStyled(Grid)({
  height: "100%",
  display: "flex",
  alignItems: "center",
});

export const HeadingText = muiStyled("div")({
  fontFamily: "Poppins",
  fontSize: "18px",
  fontWeight: "600",
  margin: "0px 5px",
  color: globalColors.primaryTextColor,
  maxWidth: "400px",
  textOverflow: "ellipsis",
  textWrap: "nowrap",
  overflow: "hidden"
});

export const HeaderLogoActionsContainer = muiStyled(Grid)({
  alignItems: "center",
  display: "flex",
  height: "100%",
  justifyContent: "space-between",
});

export const HeaderTitleContainer = muiStyled(Grid)({
  alignItems: "center",
  display: "flex",
  height: "100%",
  justifyContent: "center",
});

export const HeaderActionButtonsContainer = muiStyled(Grid)({
  alignItems: "center",
  display: "flex",
  height: "100%",
  justifyContent: "flex-end",
});

export const HeaderLogoTextContainer = muiStyled(Grid)({
  alignItems: "center",
  display: "flex",
  height: "100%",
});

export const HeaderSaveDeleteContainer = muiStyled(Grid)({
  alignItems: "center",
  display: "flex",
  height: "100%",
});

export const HeaderImageContainer = muiStyled(Grid)({
  alignItems: "center",
  backgroundColor: globalColors.logoBackground,
  color: globalColors.primaryTextColor,
  display: "flex",
  height: "100%",
  justifyContent: "center",
  width: "52px",
});

export const HeaderAvatarContainer = muiStyled(Avatar)({
  marginRight: "5px",
  height: "32px",
  width: "32px",
});

export const BodyContainer = muiStyled(Box)({
  height: "calc(100% - 55px)",
});

export const BodyHeaderContainer = muiStyled(Box)({
  alignItems: "center",
  backgroundColor: globalColors.calmLight,
  display: "flex",
  height: "60px",
});

export const BodyHeaderInnerGrid = muiStyled(Grid)({
  height: "100%",
  display: "flex",
  alignItems: "center",
});

export const UndoRedoContainer = muiStyled(Grid)({
  alignItems: "center",
  display: "flex",
  height: "100%",
  justifyContent: "flex-end",
});

export const DeviceContainer = muiStyled(Grid)({
  alignItems: "center",
  display: "flex",
  height: "100%",
  justifyContent: "center",
});

export const ExitContainer = muiStyled(Grid)({
  alignItems: "center",
  display: "flex",
  height: "100%",
  justifyContent: "flex-end",
});

export const BodyContentContainer = muiStyled(Box)({
  height: "calc(100% - 60px)",
});

export const LayoutRoot = muiStyled(Grid)({
  height: "100%",
});

export const ContentScreenLayout = muiStyled(Grid)({
  backgroundColor: globalColors.white,
  height: "100%",
  padding: "15px",
});

export const QuestionPanelLayout = muiStyled(Grid)({
  backgroundColor: globalColors.backgroundGrey,
  height: "100%",
  padding: "25px",
});

export const QuestionScreenLayout = muiStyled(Grid)({
  backgroundColor: globalColors.white,
  height: "100%",
  padding: "15px",
});

export const PreviewRootContainer = muiStyled(Box)({
  backgroundColor: globalColors.white,
  height: "100vh",
  overflow: "hidden",
});
export const ShareRootContainer = muiStyled(Box)({
  backgroundColor: globalColors.white,
  height: "100vh",
  overflow: "hidden",
});

export const PreviewHeaderContainer = muiStyled(Box)({
  height: "55px",
  display: "flex",
  alignItems: "center",
});

export const PreviewBodyContainer = muiStyled(Box)({
  height: "calc(100% - 55px)",
});

export const ShareBodyContainer = muiStyled(Box)({
  height: "calc(100% - 55px)",
});

export const PreviewBodyHeaderContainer = muiStyled(Box)({
  alignItems: "center",
  backgroundColor: globalColors.calmLight,
  display: "flex",
  height: "60px",
});

export const PreviewBodyContentContainer = muiStyled(Box)({
  height: "calc(100% - 55px)",
  backgroundColor: globalColors.white,
});
export const ShareBodyContentContainer = muiStyled(Box)({
  height: "calc(100% - 55px)",
  backgroundColor: globalColors.white,
});

export const IframeParentContainer = muiStyled("div")({
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});
